import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/SideBar";
import UserMenu from "../components/UserMenu";
import LiveNotifications from "../components/LiveNotifications";
import { connectSocket, disconnectSocket } from "../services/socket";

const Layout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Handle body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileMenuOpen]);

  // Keep socket alive for the entire session
  useEffect(() => {
    connectSocket();
    return () => disconnectSocket();
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);
  const toggleSidebarCollapse = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  return (
    <div className="flex bg-gray-50 overflow-hidden" style={{ height: "100dvh" }}>
        {/* Mobile Menu Button */}
        <button
          onClick={toggleMobileMenu}
          className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-gray-900 text-white
            hover:bg-gray-800 active:scale-95 transition-all duration-200 shadow-lg"
          aria-label="Toggle menu"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {isMobileMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Sidebar */}
        <aside
          className={`md:block flex-shrink-0 transition-all duration-300 ease-in-out ${
            isSidebarCollapsed ? "md:w-16" : "md:w-64"
          }`}
        >
          <Sidebar
            isMobileOpen={isMobileMenuOpen}
            onMobileClose={closeMobileMenu}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={toggleSidebarCollapse}
          />
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden flex flex-col">
          {/* Top Bar */}
          <header className="sticky top-0 z-30 flex items-center justify-end gap-2 px-4 h-14 bg-white border-b border-gray-200 shadow-sm flex-shrink-0">
            <LiveNotifications />
            <UserMenu />
          </header>
          <div className="flex-1 pt-2">
            <Outlet />
          </div>
        </main>
    </div>
  );
};

export default Layout;
